import React from 'react';
  
function WorkUpdates() {
    return (
        <h1>WorkUpdates</h1> 
    )
}
  
export default WorkUpdates;